/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { FerramentasDaListagem } from '../../../shared/components';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import { DialogStatusDeColaborador } from './DialogStatusDeColaborador';
import { IListagemStatus, StatusService } from '../../../shared/services/api/rh/statusDeColaborador/StatusService';


export const ListagemDeStatusDeColaborador: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const [rows, setRows] = useState<IListagemStatus[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
  
  const filter = useMemo(() => {
    return searchParams.get('filter') || '';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const [open, setOpen] = useState(false);
  const [detalhe, setdetalhe ] = useState<string>('novo');
  const handleClose = (newValue?: string) => {
    setOpen(false);
  };

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  
  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      StatusService.getAll(pagina, filter)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    });
  }, [pagina, filter, open]);

  return (
    <LayoutBaseDePagina
      titulo='Listagem de Status de Colaborador'
      barraDeFerramentas={
        <FerramentasDaListagem
          mostrarInputBusca
          textoDaBusca={filter}
          textoBotaoNovo='Adicionar'
          aoClicarEmNovo={() => {setdetalhe('novo'); setOpen(true);}}
          aoMudarTextoDeBusca={texto => setSearchParams({ filter: texto, pagina: '1' }, { replace: true })}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>;
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Descrição</TableCell>
              <TableCell>Encargos</TableCell>
              <TableCell>13º Salário</TableCell>
              <TableCell>Folha de Pagamento</TableCell>
              <TableCell>Férias</TableCell>
              <TableCell>Auxílio</TableCell>
              <TableCell>Experiência</TableCell>
              <TableCell>Diarista</TableCell>
              <TableCell>Status do Colaborador</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.idstatus} 
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => {setdetalhe(row.idstatus); setOpen(true);}}
              >
                <TableCell>{row.descricao}</TableCell>
                <TableCell><Switch size='small' checked={row.encargos}/></TableCell>
                <TableCell><Switch size='small' checked={row.salarios}/></TableCell>
                <TableCell><Switch size='small' checked={row.folha}/></TableCell>
                <TableCell><Switch size='small' checked={row.ferias}/></TableCell>
                <TableCell><Switch size='small' checked={row.auxilio}/></TableCell>
                <TableCell><Switch size='small' checked={row.experiencia}/></TableCell>
                <TableCell><Switch size='small' checked={row.diarista}/></TableCell>
                <TableCell><Switch size='small' checked={row.status}/></TableCell>
              </TableRow>
            ))}
          </TableBody>
          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > Environment.LIMITE_DE_LINHAS) && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Pagination
                    page={pagina}
                    count={Math.ceil(totalCount / Environment.LIMITE_DE_LINHAS)}
                    onChange={(_, newPage) => setSearchParams({ filter, pagina: newPage.toString() }, { replace: true })}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
      <DialogStatusDeColaborador
        id={detalhe}
        value={''}  
        open={open} 
        onClose={handleClose}
      /> 
    </LayoutBaseDePagina>
  );
};